import { Template } from "./template.js";

const Info_window = {
  data() {
    return {
      chart: {},
      dataPoints: [],
      newComment: "",

      periodDays: 2,
      startDate: new Date(new Date() - 1 * 24 * 60 * 60 * 1000)
        .toISOString()
        .substring(0, 10),
      endDate: new Date().toISOString().substring(0, 10),
      periods: 60,
      image: null,
    };
  },

  props: {
    selected: Object,

  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    isAdmin(){
      return localStorage.group=='admin';
    },
    onFileChange(e) {
      var cont = this;
      //			console.log(this.$refs.fileInput.value);
      // достаем список файлов из ивента
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      //			console.log(files[0]);
      // чтение контента
      var reader = new FileReader();
      reader.onload = (e) => {
        //результат - img в виде data:image/jpeg;base64,/9j/4AAQSkZJRgABA.. - готов к использованию даже в адресной строке
        //				console.log(e.target.result);
        //чистим
        cont.$refs.fileInput.value = "";
        //var exif = EXIF.readFromBinaryFile(new BinaryFile(e.target.result));
        //сохраняем
        this.$API(
          "static_data",
          "updateImage",
          {
            serial: this.selected.tubeData.serial,
            picture: e.target.result,
          },
          function (data) {
            cont.image = e.target.result;
            alert("Ok");
          },
          function () {}
        );
      };
      reader.readAsDataURL(files[0]);
    },
    getPhones(selected) {
      let phones = "";
      for (var key in selected.tubeData.phones) {
        phones += selected.tubeData.phones[key].phone + "\n";
      }

      console.log(selected.tubeData.phones);
      console.log(phones);
      return phones;
    },

    updateComment() {
      var cont = this;
      //сохраняем комментарий
      this.$API(
        "static_data",
        "updateComment",
        {
          tube_name: this.selected.tubeData.tube_name,
          comment: this.newComment,
        },
        function (data) {
          cont.selected.tubeData.tube_comment = cont.newComment; //если запрос прошел, записываем переменную, чтобы пропала кнопка сохранения
        },
        function () {}
      );
    },
    fillChart(data, begin, end, titleY, suffixY, dataName, yValueFormat) {
      var cont = this;

      data.some(function (el) {
        el.x = new Date(el.x * 1000);
      });
      cont.dataPoints = data;
      //let interval = Math.round((end - begin) / 1000 / 60 / 60);
      CanvasJS.addCultureInfo("ru", {
        decimalSeparator: ".",
        digitGroupSeparator: ",",
        shortMonths: [
          "Янв",
          "Фев",
          "Мар",
          "Апр",
          "Май",
          "Июн",
          "Июл",
          "Авг",
          "Сен",
          "Окт",
          "Ноя",
          "Дек",
        ],
      });
      cont.chart = new CanvasJS.Chart("chartContainer", {
        theme: "dark2", // "light2", "dark1", "dark2"
        animationEnabled: false, // change to true
        zoomEnabled: true,
        culture: cont.$i18n.locale === "ru" ? "ru" : "en",

        axisX: {
          //				valueFormatString: "DD/MM",
          minimum: begin,
          maximum: end,
          //				interval: interval,
          //				intervalType: "hour"
        },
        axisY: {
          title: titleY,
          prefix: "",
          suffix: suffixY,
          minimum: 0,
          //					maximum: 1800,
          includeZero: true,
        },
        toolTip: {
          shared: true,
        },
        legend: {
          cursor: "pointer",
          verticalAlign: "bottom",
          horizontalAlign: "center",
          dockInsidePlotArea: false,
          itemclick: cont.toogleDataSeries,
        },
        data: [
          {
            type: "line", //spline
            axisYType: "primary",
            xValueType: "dateTime",
            xValueFormatString: "DD/MM/YYYY HH:mm",
            name: dataName,
            showInLegend: true,
            color: "#ffff00",
            markerSize: 4,
            markerType: "circle",
            yValueFormatString: yValueFormat,
            connectNullData: false,
            dataPoints: cont.dataPoints,
          },
        ],
        rangeChanging: function (e) {
          //zoom, get new data
          //console.log("type : " + e.type + ", trigger : " + e.trigger + ", AxisX viewportMininum : " + e.axisX[0].viewportMinimum + ",AxisX viewportMaximum : " + e.axisX[0].viewportMaximum);
        },
      });

      cont.chart.render();
    },
    toogleDataSeries(e) {
      if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
        e.dataSeries.visible = false;
      } else {
        e.dataSeries.visible = true;
      }
      this.chart.render();
    },
    changeRange(days) {
      this.periodDays = days;
      this.startDate = new Date(new Date() - (days - 1) * 24 * 60 * 60 * 1000)
        .toISOString()
        .substring(0, 10);
      this.endDate = new Date().toISOString().substring(0, 10);
    },
    getArchiveData(begin, end) {
      var cont = this;
      if (this.selected) {
        let api = "archive";
        let titleY = cont.$t("tubes.isolResistance");
        let suffixY = cont.$t("tubes.kOhm");
        let dataName = cont.$t("tubes.isol");
        let yValueFormat = `### ${cont.$t("tubes.kOhm")}`;

        // if(this.selected.tubeData.onewire_t && this.selected.tubeData.onewire_t.length){
        if(this.selected.tubeData.onewire_t != ""){
          api = "onewire_t";
          titleY = cont.$t("modems.temperature");
          suffixY = cont.$t("modems.temperatureUnit");
          dataName = cont.$t("modems.onewire");
          yValueFormat = `#,##0.## ${cont.$t("modems.temperatureUnit")}`;
        }
        
        if(this.selected.tubeData.onewire_p && this.selected.tubeData.onewire_p.length){
          api = "onewire_p";
          titleY = cont.$t("modems.pressure");
          suffixY = globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit;
          dataName = cont.$t("modems.onewireP");
          yValueFormat = `#,##0.##  ${globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit}`;
        }


        let periodBegin = new Date(cont.startDate).getTime() / 1000;
        let periodEnd = new Date(cont.endDate).getTime() / 1000 + 60 * 60 * 24;
        //посчитаем период, если он заканчивается сегодня
        let today = new Date().toISOString().substring(0, 10);
        if (cont.endDate == today) {
          let diffTime = periodEnd - periodBegin;
          let diffDays = Math.ceil(diffTime / (60 * 60 * 24));
          this.periodDays = diffDays;
        } else {
          this.periodDays = 0;
        }

        cont.$API(
          "static_data",
            api,
          {
            serial: this.selected.tubeData.serial,
            begin: periodBegin,
            end: periodEnd,
            periods: this.periods,
          },
            function (data) {
              cont.fillChart(
                  data,
                  (periodBegin + new Date().getTimezoneOffset() * 60) * 1000,
                  (periodEnd + new Date().getTimezoneOffset() * 60) * 1000,
                  titleY,
                  suffixY,
                  dataName,
                  yValueFormat
              );
            },
          function () {}
        );
      } else cont.chart.clear();
    },
    getImage() {
      var cont = this;
      if (this.selected) {
        cont.image = null;

        cont.$API(
          "static_data",
          "getImage",
          {
            serial: this.selected.tubeData.serial,
          },
          function (data) {
            cont.image = data.picture;
          },
          function () {}
        );
      } else cont.chart.clear();
    },
    openImage() {
      //			window.open().document.body.innerHTML = "<img style='max-width:100%;max-height:100%' src='" + this.image +"'>";
      window
        .open()
        .document.write(
          "<html><body style='width:100%;height:100%'><img style='max-width:100%;max-height:100%' src='" +
            this.image +
            "'></body></html>"
        );
    },
  },
  watch: {
    locale() {
      this.getArchiveData();
    },
    selected: {
      handler: function () {
        this.getArchiveData();
        this.getImage();
        this.newComment = this.selected.tubeData.tube_comment;
      },

      immediate: true,
    },
    startDate() {
      this.getArchiveData();
    },
    endDate() {
      this.getArchiveData();
    },
  },

  template: Template,
};

export { Info_window };



// WEBPACK FOOTER //
// ./src/app/js/components/page1_tubes/info_window/component.js